<template>
  <section class="listing">
    <div class="header">
      <div class="title">Usuários</div>
      <button @click="$router.push('/usuario/new')" class="button-new"><i class="fas fa-plus"></i><span>NOVO</span></button>
    </div>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading">
        <div v-for="user in users" :key="user.id" class="list">
          <div class="data">
            <div class="main-data">{{ user.name }}</div>
            <div class="detail-data">{{ user.login }}</div>
          </div>
          <div class="actions">
            <button @click="$router.push(`/usuario/${user.id}`)" class="button-action"><i class="fas fa-pen"></i><span>ALTERAR</span></button>
          </div>
        </div>
      </div>
    </transition>
    <User v-if="user" :id="user" />
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll } from '../api/businessUser'
import User from './User.vue'

export default {
  name: 'users',
  components: { User },
  props: ['id'],
  data () {
    return {
      loading: true,
      user: null,
      users: []
    }
  },
  watch: {
    async '$route' (value) {
      this.user = value.params['id'] || null
      // Update list
      if (!value.params['id']) {
        try {
          this.loading = true
          this.users = await getAll()
          this.loading = false
        } catch (error) {
          logger.error(error, this)
        }
      }
    }
  },
  async mounted () {
    try {
      this.user = this.id || null
      this.users = await getAll()
      this.loading = false
    } catch (error) {
      logger.error(error, this)
    }
  }
}
</script>
